/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSTag.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */ 
namespace WinAnimation.Line {
    import DisplayObject = PIXI.DisplayObject;    
    /**
   * Tag class is used to handle all common mehtods for desktop and mobile versions
   * @author <a href=mailto:snethani@gauselmann.com>Sujata Nethani</a>
   * @version $Revision: 1.0 $ $Date:  3 July 2020 $
   */    
    export class BSTag extends Tag {
        protected _view: Phaser.Group;
        private normalTag: DisplayObject;
        private greyedTag: DisplayObject;
        private litTag: DisplayObject;

        constructor(view: Phaser.Group, normalTag?: DisplayObject, greyedTag?: DisplayObject, litTag?: DisplayObject) {
            super(view);
            if (normalTag) {
                this.normalTag = normalTag;
                this.normalTag.visible = true;
                this._view.add(normalTag);
            }
            if (greyedTag) {
                this.greyedTag = greyedTag;
                this.greyedTag.visible = false;
                this._view.add(greyedTag);
            }
            if (litTag) {
                this.litTag = litTag;
                this.litTag.visible = false;
                this._view.add(litTag);
            }
        }
        public highlight(): void {
            super.highlight();
            this.greyedTag.visible = false;
            this.normalTag.visible = false;
            this.litTag.visible = true;
        }
        public select(): void {
            super.select();
            this.greyedTag.visible = false;
            this.normalTag.visible = true;
            this.litTag.visible = false;
        }
        public selectLine(): void {
            super.select();
            this.greyedTag.visible = true;
            this.normalTag.visible = false;
            this.litTag.visible = false;
        }

        public deselect(): void {
            super.deselect();
            this.greyedTag.visible = true;
            this.normalTag.visible = false;
            this.litTag.visible = false;
        }
        get view(): Phaser.Group {
            return this._view;
        }
        set view(value: Phaser.Group) {
            this._view = value;
        }
    }
}